import { headerConnect as connect } from 'components/Shared/connect';
import Modal from 'components/Shared/Modal';
import Button from 'components/Shared/Button';
import { notificationClose } from './actions';

interface MergedProps {
  text?: string;
  show: boolean;
  title?: string;
  onClose: () => void;
}
const Notification = ({ show, text, title, onClose }: MergedProps) =>
  (shouldShow(show) && (
    <div id="notification">
      <Modal show={show} onClose={onClose}>
        {title && <h2>{title}</h2>}
        {text && <div dangerouslySetInnerHTML={{ __html: text }} />}
        <Button onClick={onClose}>Stäng</Button>
      </Modal>
    </div>
  )) as React.FunctionComponentElement<Record<string, unknown>>;

const shouldShow = (show: boolean) => show;

export default connect<MergedProps>(
  state => {
    if (!state.notification) {
      return { show: false };
    }
    return {
      text: state.notification && state.notification.text,
      show: state.notification && state.notification.show,
      title: state.notification && state.notification.title
    };
  },
  dispatch => ({
    onClose: () => dispatch(notificationClose())
  })
)(Notification);
